<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        {{ $t("sendNotification") }}
        <v-spacer />
        <v-btn fab small text @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-tabs v-model="tab">
          <v-tab href="#omtk">{{ $t("toOMTK") }}</v-tab>
          <v-tab href="#accounting">{{ $t("toAccounting") }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item value="omtk">
            <form @submit.prevent="send">
              <custom-text-textarea
                v-model="formData.body"
                :label="$t('comment')"
                class="user_input"
              />
              <div class="text-right mt-3">
                <v-btn class="mr-2" color="secondary" @click="dialog = false">{{
                  $t("toCancel")
                }}</v-btn>
                <v-btn :loading="loading" color="primary" type="submit">{{
                  $t("send")
                }}</v-btn>
              </div>
            </form>
          </v-tab-item>
          <v-tab-item value="accounting">
            <validation-observer ref="formObs" v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(sendAccounting)">
                <custom-text-textarea
                  v-model="formData.body"
                  :label="$t('comment')"
                  class="user_input mb-5"
                />
                <div class="text-right mt-3">
                  <v-btn
                    class="mr-2"
                    color="secondary"
                    @click="dialog = false"
                    >{{ $t("toCancel") }}</v-btn
                  >
                  <v-btn :loading="loading" color="primary" type="submit">{{
                    $t("send")
                  }}</v-btn>
                </div>
              </form>
            </validation-observer>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ozlNotificationToOmtk",
  data() {
    return {
      info: {},
      dialog: false,
      loading: false,
      tab: "omtk",
      formData: {
        body: null,
        contractItemId: null,
      },
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.clear();
      }
    },
    tab(val) {
      if (val === "omtk") {
        this.formData.body = this.$t(
          "notificationTemplate.ozlToOmtkProfitProduct",
          {
            contractNumber: this.info.contractNumber,
            productName: this.info.productName,
          }
        );
      } else {
        this.formData.body = this.$t(
          "notificationTemplate.ozlToAccountProfitProduct",
          {
            contractNumber: this.info.contractNumber,
          }
        );
      }
    },
  },
  methods: {
    clear() {
      const { formObs } = this.$refs;
      this.tab = "omtk";
      this.formData = { body: null, contractItemId: null };
      if (formObs) formObs.reset();
      this.info = {};
      this.dialog = false;
    },
    defaultCommentTemplate({ contractNumber, productName }) {
      return this.$t("notificationTemplate.ozlToOmtkProfitProduct", {
        contractNumber,
        productName,
      });
    },
    async send() {
      try {
        this.loading = true;
        await this.$http.post(
          "notification/contract/ozl-to-omtk",
          this.formData
        );
        this.setSuccess({ text: this.$t("successfullySent") });
        this.clear();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    async sendAccounting() {
      try {
        this.loading = true;
        await this.$http.post(
          "notification/contract/ozl-to-accountant",
          this.formData
        );
        this.setSuccess({ text: this.$t("successfullySent") });
        this.clear();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    open(contractItemId, { contractNumber, productName }) {
      this.info = {
        contractNumber,
        productName,
        contractItemId,
      };
      this.formData = {
        contractItemId,
        body: this.defaultCommentTemplate({ productName, contractNumber }),
      };
      this.dialog = true;
    },
  },
};
</script>
